<template>
    <form v-on:submit.prevent="editProduct">
        <div class="modal-card">
            <header class="modal-card-head" style="background:#222">
                <p class="modal-card-title" style="color:white"><span style="color: #7cda24">Send Message to</span> {{user.name}}</p>
            </header>
            <section class="modal-card-body">
              <b-field label="Channel">
                  <b-select v-model="selectedChannel" placeholder="Whatsapp/SMS">
                      <option
                          v-for="channel in channels"
                          :value="channel"
                          :key="channel">
                          {{ channel }}
                      </option>
                  </b-select>
              </b-field>
              <b-field label="Message">
                <b-input type="textarea" v-model="message"></b-input>
              </b-field>
            </section>
            <footer class="modal-card-foot">
                <a class="button is-primary is-outlined" target="_blank" :href="`https://wa.me/263${user.mobile_number}${whatsappMessage}`" @click="sendWhatsapp" v-if="selectedChannel=='Whatsapp'">Send Whatsapp</a>
                <button class="button is-primary is-outlined" type="button" @click="sendSMS" v-else>Send SMS</button>

                <button class="button is-dark" type="button" @click="$parent.close">Close</button>
            </footer>
        </div>
    </form>
</template>

<script>
import { ucFirst, currencies, ls } from '@/helpers';
import { mapGetters } from 'vuex';

export default {
    name: "SendMessageModal",
    data() {
      return {
        currencies,
        channels: ['Whatsapp', 'SMS'],
        selectedChannel: 'SMS',
        message: ''
      }
    },
    props: ['user'],
    computed: {
      whatsappMessage() {
        return `?text=${encodeURI(this.message)}`
      }
    },
    created() {
    },
    methods: {
        getCategories() {
            this.$store.dispatch('getCategories');
        },
        sendSMS() {
          const loading = this.$loading.open();
          this.$store.dispatch('sendSMS', {to: this.user.mobile_number, message: this.message }).then(() => {
            loading.close();
            this.$parent.close();
            this.$toasted.global.success(`SMS Sent to ${this.user.name}!`);
          }).catch(e=> {
            loading.close();
            console.log('Exception when sending sms',e);
            this.$toasted.global.error('Failed to send SMS. Please try again.');
          })
        },
        sendWhatsapp() {}
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SoilTests/SendMessageModal.vue